export default "/_next/static/chunks/fonts/Montserrat-Black-latin-1f63308bd6c2d6ae27d2e8a31d1a7514.woff2";